import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createSlots as _createSlots, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d0fb8ce0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-full h-full overflow-y-auto content-box max-w-14xl" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "课程评价", -1))
const _hoisted_3 = { class: "flex-shrink-0 info-bar" }
const _hoisted_4 = {
  key: 0,
  class: "h-16"
}
const _hoisted_5 = {
  key: 1,
  class: "info-bar__head"
}
const _hoisted_6 = { class: "info-bar__head-left" }
const _hoisted_7 = { class: "lecture-title" }
const _hoisted_8 = { class: "mr-2 text-2xl text-black" }
const _hoisted_9 = { class: "text-base text-gray-600" }
const _hoisted_10 = { class: "lecture-recommended-score" }
const _hoisted_11 = { class: "text-gray-500" }
const _hoisted_12 = { class: "info-bar__action" }
const _hoisted_13 = {
  key: 1,
  class: "info-bar__watch"
}
const _hoisted_14 = {
  key: 2,
  class: "info-bar__rating-outline h-14 animate-pulse"
}
const _hoisted_15 = {
  key: 3,
  class: "info-bar__rating-outline"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600" }, " 难易程度 ", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600" }, " 给分好坏 ", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600" }, " 工作量 ", -1))
const _hoisted_19 = { class: "rating-bar" }
const _hoisted_20 = { class: "rating-bar__header" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "课程点评", -1))
const _hoisted_22 = { class: "rating-bar__list" }
const _hoisted_23 = {
  key: 0,
  class: "p-4 pb-2 mb-3 bg-white rounded-lg h-44"
}
const _hoisted_24 = { class: "mt-4" }
const _hoisted_25 = {
  key: 1,
  class: "rating-bar__empty"
}
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" 你来到了一块空地，来")
const _hoisted_27 = /*#__PURE__*/_createTextVNode("吧！ ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_rating_head_bar = _resolveComponent("rating-head-bar")!
  const _component_f_skeleton = _resolveComponent("f-skeleton")!
  const _component_five_stars = _resolveComponent("five-stars")!
  const _component_f_icon = _resolveComponent("f-icon")!
  const _component_f_button = _resolveComponent("f-button")!
  const _component_lecture_detail_info = _resolveComponent("lecture-detail-info")!
  const _component_card_reactive_rating = _resolveComponent("card-reactive-rating")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_rating_head_bar, {
      "is-back-visible": "",
      onClickBack: _cache[0] || (_cache[0] = ($event: any) => (_ctx.routerBack('/rating')))
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_f_skeleton, { width: ['300px', '144px'] })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.lectureInfo.name), 1),
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.lectureInfo.taughtBy.join(' ')), 1)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_five_stars, {
                  score: _ctx.lectureInfo.recommended,
                  size: 18,
                  spacing: 3
                }, null, 8, ["score"]),
                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.lectureInfo.recommended.toFixed(1)), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              false
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "info-bar__star",
                    style: _normalizeStyle({
              color: _ctx.lectureInfo.starred ? '#ef755a' : '#828282',
            })
                  }, [
                    _createVNode(_component_f_icon, {
                      class: "icon-star",
                      name: _ctx.lectureInfo.starred ? 'heart-fill' : 'heart',
                      size: 24,
                      onClick: _ctx.handleClickStar
                    }, null, 8, ["name", "onClick"]),
                    _createElementVNode("span", null, _toDisplayString(_ctx.lectureInfo.starCount), 1)
                  ], 4))
                : _createCommentVNode("", true),
              false
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createVNode(_component_f_button, {
                      type: "primary",
                      shape: "circle",
                      size: "small",
                      class: _normalizeClass(["info-bar__watch-button text-gray-600", { 'info-bar__watch-button--watched': _ctx.lectureInfo.watched }]),
                      onClick: _ctx.handleClickWatch
                    }, _createSlots({
                      default: _withCtx(() => [
                        _createTextVNode(" " + _toDisplayString(_ctx.lectureInfo.watched ? '已关注' : '关注'), 1)
                      ]),
                      _: 2
                    }, [
                      (!_ctx.lectureInfo.watched)
                        ? {
                            name: "icon",
                            fn: _withCtx(() => [
                              _createVNode(_component_f_icon, {
                                class: "mr-1",
                                name: "plus",
                                size: 10
                              })
                            ])
                          }
                        : undefined
                    ]), 1032, ["class", "onClick"])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14))
        : (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createElementVNode("div", null, [
              _hoisted_16,
              _createElementVNode("div", null, _toDisplayString(_ctx.mapScoreToText('difficulty', _ctx.lectureInfo.difficulty)), 1)
            ]),
            _createElementVNode("div", null, [
              _hoisted_17,
              _createElementVNode("div", null, _toDisplayString(_ctx.mapScoreToText('nice', _ctx.lectureInfo.nice)), 1)
            ]),
            _createElementVNode("div", null, [
              _hoisted_18,
              _createElementVNode("div", null, _toDisplayString(_ctx.mapScoreToText('workload', _ctx.lectureInfo.workload)), 1)
            ])
          ])),
      _createVNode(_component_lecture_detail_info, {
        "lecture-info": _ctx.lectureInfo,
        loading: _ctx.loading
      }, null, 8, ["lecture-info", "loading"])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, [
        _hoisted_21,
        _createVNode(_component_f_button, {
          type: "primary",
          size: "small",
          shape: "round",
          onClick: _ctx.handleEditRating
        }, {
          icon: _withCtx(() => [
            _createVNode(_component_f_icon, {
              class: "mr-1",
              name: "edit",
              size: 14
            })
          ]),
          default: _withCtx(() => [
            _createTextVNode(" " + _toDisplayString(_ctx.lectureInfo.rated ? '编辑点评' : '我要点评'), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _createElementVNode("div", _hoisted_22, [
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
              _createVNode(_component_f_skeleton, {
                avatar: "",
                width: ['180px', '120px']
              }),
              _createElementVNode("div", _hoisted_24, [
                _createVNode(_component_f_skeleton, {
                  rows: 3,
                  width: "50%"
                })
              ])
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ratingList, (rating) => {
          return (_openBlock(), _createBlock(_component_card_reactive_rating, {
            key: rating.id,
            rating: rating,
            "show-delete": _ctx.isCurrentUser(rating.creator.id),
            "show-edit": _ctx.isCurrentUser(rating.creator.id),
            onClickDelete: _ctx.deleteShow,
            onClickEdit: _ctx.handleEditRating
          }, null, 8, ["rating", "show-delete", "show-edit", "onClickDelete", "onClickEdit"]))
        }), 128)),
        (!_ctx.loading && _ctx.ratingList.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
              _hoisted_26,
              _createElementVNode("span", {
                class: "f-clickable text-primary",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleEditRating && _ctx.handleEditRating(...args)))
              }, "第一个点评"),
              _hoisted_27
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}